import { Lock } from "lucide-react";

type Variant = "section" | "inline";

type Props = {
  count?: number;
  variant?: Variant;
  className?: string;
};

// Discreto: comunica al usuario que algunos campos fueron ocultados por su rol.
// Diseñado para `lot_cost_allocated.amount` redactado a operator (commit 715f229)
// pero reusable para cualquier campo sensible que el backend redacta por rol.
export function RedactionBanner({ count, variant = "section", className }: Props) {
  const base =
    "inline-flex items-center gap-2 rounded-xl border border-app-border bg-app-surface-2 text-app-ink-2";

  const sizing = variant === "inline" ? "px-2 py-1 text-[11px]" : "w-full px-3 py-2 text-[12px]";

  const message = buildMessage(count);

  return (
    <div
      role="note"
      aria-label="Información sobre datos ocultos por rol"
      className={[base, sizing, className].filter(Boolean).join(" ")}
    >
      <Lock aria-hidden className="h-3.5 w-3.5 shrink-0 text-app-ink-3" />
      <span>{message}</span>
    </div>
  );
}

function buildMessage(count: number | undefined): string {
  if (typeof count === "number" && count > 0) {
    if (count === 1) return "Un monto está oculto según tu rol.";
    return `${count} montos están ocultos según tu rol.`;
  }
  return "Algunos montos están ocultos según tu rol.";
}
